import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Button, Grid, Typography , Menu , MenuItem ,Box} from "@mui/material";
import {EditOutlined ,DeleteOutline , History} from "@mui/icons-material";
import { DataGrid ,GridToolbarContainer, GridToolbarDensitySelector, } from "@mui/x-data-grid";
import { GridToolbarQuickFilter } from '@mui/x-data-grid';
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";

import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import _ from "lodash";

//Services
import dispatcherApi from "Services/Dispatcher";

//Modals
import DispatcherAddModal from "Pages/Modals/Dispatcher/Create";
import DispatcherUpdateModal from "Pages/Modals/Dispatcher/Update";
import DispatcherDeleteDialog from "Pages/Modals/Dispatcher/Delete";

const Passenger = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //

  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ""
  );

  const [row, setRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);  
  const [currentRowData, setCurrentRowData] = useState({}); // State to hold the current row data
  const [customerId, setCustomerId] = useState("");

  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(10); // Initial page size
  const [totalPages, setTotalPages] = useState(1);
 const [searchText, setSearchText] = useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openaction = Boolean(anchorEl);
  const handleClick = (event, rowData) => {
    setCurrentRowData(rowData);
    setAnchorEl(event.currentTarget);
  };
  const handleCloseaction = () => {
    setAnchorEl(null);
  };
  //Modals

  const [addDispatcherModal, setAddDispatcherModal] = useState(false);
  
  const handleOpenAddDispatcherModal = () => {
    setAddDispatcherModal(true);
  };

  const handleCloseAddDispatcherModal = () => {
    setAddDispatcherModal(false);
    getDispatchers();
  };

  const [updateDispatcherModal, setUpdateDispatcherModal] = useState(false);

  const handleOpenUpdateDispatcherModal = (row) => {
    setCustomerId(row?._id);
    setUpdateDispatcherModal(true);
    setAnchorEl(null);
  };

  const handleCloseUpdateDispatcherModal = () => {
    setUpdateDispatcherModal(false);
    getDispatchers();
  };

  const [deleteDispatcherModal, setdeleteDispatcherModal] = useState(false);

  const handleOpenDeleteDispatcherModal = (row) => {
    setCustomerId(row?._id);
    setdeleteDispatcherModal(true);
    setAnchorEl(null);
  };

  const handleCloseDeleteServiceModal = (row) => {
    setdeleteDispatcherModal(false);
    getDispatchers();
  };

  // Get Passenger list api
  const getDispatchers = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    const params = { page, limit: pageSize, search: searchText };
    if (demoaccount_id) {
      params.demoaccount_id = demoaccount_id;
    }
    dispatcherApi
      .getDispatchersList(params)
      .then(onSuccess, onFailure);
  }, [page, pageSize, searchText, demoaccount_id]);

  const getAllDispatchers = useCallback(() => {
  //  dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setbulkrow(res?.data?.data?.data);
      } else {
        setbulkrow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    const params = { page:1, limit: "unlimited", search: "" };
    if (demoaccount_id) {
      params.demoaccount_id = demoaccount_id;
    }
    dispatcherApi
      .getDispatchersList(params)
      .then(onSuccess, onFailure);
  }, [demoaccount_id]);

  useEffect(() => {
    getDispatchers();
    getAllDispatchers();
  }, [getDispatchers, getAllDispatchers]);

  const handleDownloadAll = () => {
    const csv = Papa.unparse(bulkformatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "All DispatcherList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handlePageChange = (newPage) => {
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  const handleCopy = () => {
      // Define column widths
      const columnWidths = [5, 15, 25, 15, 15]; // Adjust widths as needed
  
      // Helper function to pad text to the desired width
      const padText = (text, width) => {
        return (text ?? "").toString().padEnd(width, " ");
      };
      // Create table header
      const header = [
        padText("S.NO", columnWidths[0]),
        padText("First name", columnWidths[1]),
        padText("Email", columnWidths[2]),
        padText("Mobile", columnWidths[3]),
        padText("Status", columnWidths[4])
      ].join("");
    
      // Create table rows
      const rows = dataRows
        .map((row) =>
          [
            padText(row.sno, columnWidths[0]),
            padText(row.firstName, columnWidths[1]),
            padText(row.email, columnWidths[2]),
            padText(row.mobile, columnWidths[3]),
            padText(row.status, columnWidths[4])
          ].join("")
        )
        .join("\n");
    
      // Combine header and rows
      const formattedContent = [header, rows].join("\n");
    
      // Copy to clipboard
      navigator.clipboard.writeText(formattedContent).then(() => {
        alert("Table copied to clipboard!");
      });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Services");
    XLSX.writeFile(workbook, "DispatcherList.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "DispatcherList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((row) => [
      row.sno,
      row.firstName,
      row.email,
      row.mobile,
      row.status
    ]);
    doc.autoTable({
      head: [["S.NO","First Name","Email","Mobile","Status"]],
      body: tableData,
    });
    doc.save("DispatcherList.pdf");
  };

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };


    function CustomToolbar() {
      return (
  <Box sx={{ p: 1, pb: 0, display: "flex", justifyContent: "flex-start" }}>
  <GridToolbarQuickFilter debounceMs={800} autoFocus/>
  <GridToolbarContainer>
  <GridToolbarDensitySelector />
  </GridToolbarContainer>
  </Box>
      );
    }

  const dataRows = _.map(row || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    firstName: data?.firstName,
    email: data?.email,
    mobile: data?.countryCode+" "+data?.mobileNumber,
    status: data?.isActive === 1 ? "Active" : "Inactive" ,
    background: data?.isActive === 1 ? "#34ab4d" : "#f44336" ,
    row: data,
  }));

  const formatteddatas = dataRows.map((row) => ({
    "S.NO": row.sno,
    "First Name":row.firstName,
    "Email":row.email,
    "Mobile": row.mobile,
    "Status": row.status
  }));
  
  const bulkdataRows = _.map(
    _.orderBy(bulkrow || [], ['createdAt'], ['asc']),
    (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    firstName: data?.firstName,
    email: data?.email,
    mobile: data?.countryCode+" "+data?.mobileNumber,
    status: data?.isActive === 1 ? "Active" : "Inactive" ,
    background: data?.isActive === 1 ? "#34ab4d" : "#f44336" ,
    row: data,
  }));  
  
  const bulkformatteddatas = bulkdataRows.map((row) => ({
    "S.NO": row.sno,
    "First Name":row.firstName,
    "Email":row.email,
    "Mobile": row.mobile,
    "Status": row.status
  }));  

  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex:0.5,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "firstName",
      headerName: "First Name",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.firstName}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.email}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "mobile",
      headerName: "Mobile",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.mobile}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2" className={classes.statuscolumn} 
              sx={{ background:params?.row?.background}}>{params?.row?.status}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      flex:1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const rowData = params?.row?.row;
        return (
          <div className={classes.iconsWrapper}>
            {/* Action Button with Dropdown */}
            <Button
              id="basic-button"
              aria-controls={openaction ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={openaction ? "true" : undefined}
              onClick={(e) => handleClick(e, rowData)}
            >
              Action
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={openaction}
              onClose={handleCloseaction}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
      
              {/* Edit Option */}
              <MenuItem onClick={() => handleOpenUpdateDispatcherModal(currentRowData)}>
                <section className={classes.editIcon}>
                  <EditOutlined />
                  <Typography variant="subtitle2" gutterBottom className={classes.actiontypo}>
                    Edit
                  </Typography>
                </section>
              </MenuItem>
      
              {/* Delete Option */}
              <MenuItem onClick={() => handleOpenDeleteDispatcherModal(currentRowData)}>
                <section className={classes.deleteIcon}>
                  <DeleteOutline />
                  <Typography variant="subtitle2" gutterBottom className={classes.actiontypo}>
                    Delete
                  </Typography>
                </section>
              </MenuItem>
            </Menu>
          </div>
        );
      }
    }
  ];

  return (
    <>
      <Grid container className={classes.root}>
      <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleCopy}>
            COPY
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleDownloadExcel}>
            EXCEL
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleDownloadCSV}>
            CSV
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleDownloadPDF}>
            PDF
          </Button>
        </Grid>
      <Grid item xs={2} md={2} lg={2} xl={2} className={classes.funBtn}>
      <Button variant="contained" onClick={handleDownloadAll}>
      Download ALL
      </Button>
      </Grid>        
        <Grid item xs={6} md={6} lg={6} xl={6} className={classes.addBtn}>
          <Button variant="contained" onClick={handleOpenAddDispatcherModal}>
            Add Dispatcher
          </Button>
        </Grid>
        <Grid item xs={12}>
          <section className={classes.dataGridTable}>
            <DataGrid
              getRowId={(row) => row?.row?._id}
              rows={dataRows}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => {
                setPageSize(newPageSize);
                setPage(1);
              }}
              onPageChange={(newPage) => handlePageChange(newPage)}
              rowsPerPageOptions={[5, 10, 25, 50]}
              pagination
              autoHeight={true}
              disableSelectionOnClick
              scrollbarSize={4}
              rowHeight={70}
              style={{ padding: "10px", borderRadius: "0px" }}
              paginationMode="server"
              rowCount={totalPages}
              filterMode="server"
                onFilterModelChange={(model) => {
        const value = model?.quickFilterValues?.join(" ") || "";
       // console.log(value);
        setSearchText(value);          
        }}   
          density="compact"
        components={{
          Toolbar:CustomToolbar,
        }}  
            />
          </section>
        </Grid>
      </Grid>
      <DispatcherAddModal
        openDialog={addDispatcherModal}
        handleClose={handleCloseAddDispatcherModal}
      ></DispatcherAddModal>
      <DispatcherUpdateModal
        openDialog={updateDispatcherModal}
        id={customerId}
        handleClose={handleCloseUpdateDispatcherModal}
      ></DispatcherUpdateModal>
      <DispatcherDeleteDialog
      openDialog={deleteDispatcherModal}
      id={customerId}
      handleClose={handleCloseDeleteServiceModal}
    ></DispatcherDeleteDialog>
    </>
  );
};

export default Passenger;
